export default __webpack_public_path__ + "static/media/new_milestone.430cd462.svg";